import { AfterViewInit, Component, Input } from '@angular/core';
import { NgOptimizedImage } from "@angular/common";

@Component({
  selector: 'center-loader',
  providers: [],
  styleUrls: ['./center-loader.scss'],
  standalone: true,
  imports: [
    NgOptimizedImage
  ],
  templateUrl: './center-loader.html'
})
export class CenterLoaderComponent   {

    constructor(
    ) {
    }


}
